module.exports = __webpack_public_path__ + "static/img/4.cb4d0b7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/3/zh/4.png
// module id = PJ1P
// module chunks = 0